//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAreaGroupLookupClient {
    get(id: number): Observable<SampleAreaLookup>;
    getAll(): Observable<SampleAreaLookup[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AreaGroupLookupClient implements IAreaGroupLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<SampleAreaLookup> {
        let url_ = this.baseUrl + "/api/AreaGroupLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleAreaLookup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleAreaLookup>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SampleAreaLookup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleAreaLookup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<SampleAreaLookup[]> {
        let url_ = this.baseUrl + "/api/AreaGroupLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleAreaLookup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleAreaLookup[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SampleAreaLookup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SampleAreaLookup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBioGroupLookupClient {
    get(id: number): Observable<BioGroupDTO>;
    getAll(): Observable<BioGroupDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class BioGroupLookupClient implements IBioGroupLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<BioGroupDTO> {
        let url_ = this.baseUrl + "/api/BioGroupLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BioGroupDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BioGroupDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BioGroupDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BioGroupDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<BioGroupDTO[]> {
        let url_ = this.baseUrl + "/api/BioGroupLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BioGroupDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BioGroupDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BioGroupDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BioGroupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBodyParLookupClient {
    get(id: number): Observable<BodyParDTO>;
    getAll(): Observable<BodyParDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class BodyParLookupClient implements IBodyParLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<BodyParDTO> {
        let url_ = this.baseUrl + "/api/BodyParLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BodyParDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BodyParDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BodyParDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BodyParDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<BodyParDTO[]> {
        let url_ = this.baseUrl + "/api/BodyParLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BodyParDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BodyParDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BodyParDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BodyParDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICounmetLookupClient {
    get(id: number): Observable<CounmetDTO>;
    getAll(): Observable<CounmetDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CounmetLookupClient implements ICounmetLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<CounmetDTO> {
        let url_ = this.baseUrl + "/api/CounmetLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CounmetDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CounmetDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CounmetDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CounmetDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CounmetDTO[]> {
        let url_ = this.baseUrl + "/api/CounmetLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CounmetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CounmetDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CounmetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CounmetDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDrymetLookupClient {
    get(id: number): Observable<DrymetDTO>;
    getAll(): Observable<DrymetDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DrymetLookupClient implements IDrymetLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<DrymetDTO> {
        let url_ = this.baseUrl + "/api/DrymetLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrymetDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrymetDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DrymetDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrymetDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<DrymetDTO[]> {
        let url_ = this.baseUrl + "/api/DrymetLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrymetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrymetDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DrymetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrymetDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILabLookupClient {
    get(id: number): Observable<LabDTO>;
    getAll(): Observable<LabDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class LabLookupClient implements ILabLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<LabDTO> {
        let url_ = this.baseUrl + "/api/LabLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LabDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LabDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LabDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LabDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<LabDTO[]> {
        let url_ = this.baseUrl + "/api/LabLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LabDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LabDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LabDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INuclideLookupClient {
    get(id: number): Observable<NuclideDTO>;
    getAll(): Observable<NuclideDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class NuclideLookupClient implements INuclideLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<NuclideDTO> {
        let url_ = this.baseUrl + "/api/NuclideLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NuclideDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NuclideDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NuclideDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NuclideDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<NuclideDTO[]> {
        let url_ = this.baseUrl + "/api/NuclideLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NuclideDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NuclideDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NuclideDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NuclideDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPrepmetLookupClient {
    get(id: number): Observable<PrepmetDTO>;
    getAll(): Observable<PrepmetDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PrepmetLookupClient implements IPrepmetLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<PrepmetDTO> {
        let url_ = this.baseUrl + "/api/PrepmetLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrepmetDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrepmetDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PrepmetDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrepmetDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<PrepmetDTO[]> {
        let url_ = this.baseUrl + "/api/PrepmetLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrepmetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrepmetDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PrepmetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrepmetDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPublicIpClient {
    getPublicIpAddressGET(): Observable<string>;
    getPublicIpAddressPOST(): Observable<string>;
    getPublicIpAddressPUT(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class PublicIpClient implements IPublicIpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPublicIpAddressGET(): Observable<string> {
        let url_ = this.baseUrl + "/api/PublicIp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicIpAddressGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicIpAddressGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPublicIpAddressGET(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicIpAddressPOST(): Observable<string> {
        let url_ = this.baseUrl + "/api/PublicIp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicIpAddressPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicIpAddressPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPublicIpAddressPOST(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicIpAddressPUT(): Observable<string> {
        let url_ = this.baseUrl + "/api/PublicIp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicIpAddressPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicIpAddressPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPublicIpAddressPUT(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReferenceLookupClient {
    get(id: number): Observable<RefLookup>;
    getAll(): Observable<RefLookup[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReferenceLookupClient implements IReferenceLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<RefLookup> {
        let url_ = this.baseUrl + "/api/ReferenceLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefLookup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefLookup>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RefLookup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefLookup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<RefLookup[]> {
        let url_ = this.baseUrl + "/api/ReferenceLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefLookup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefLookup[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RefLookup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefLookup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISampmetLookupClient {
    get(id: number): Observable<SampmetDTO>;
    getAll(): Observable<SampmetDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SampmetLookupClient implements ISampmetLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<SampmetDTO> {
        let url_ = this.baseUrl + "/api/SampmetLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampmetDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampmetDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SampmetDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampmetDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<SampmetDTO[]> {
        let url_ = this.baseUrl + "/api/SampmetLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampmetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampmetDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SampmetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SampmetDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISampTypeLookupClient {
    get(id: number): Observable<SampTypeDTO>;
    getAll(): Observable<SampTypeDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SampTypeLookupClient implements ISampTypeLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<SampTypeDTO> {
        let url_ = this.baseUrl + "/api/SampTypeLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampTypeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampTypeDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SampTypeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampTypeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<SampTypeDTO[]> {
        let url_ = this.baseUrl + "/api/SampTypeLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampTypeDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampTypeDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SampTypeDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SampTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISearchClient {
    exportGeographySampleData(measurementMode: boolean | undefined, exportGeographySampleFilter: ExportGeographySampleFilterDTO): Observable<FileResponse>;
    exportSampleData(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse>;
    exportSampleDataFromDataSet(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse>;
    exportSampleNetCDFData(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse>;
    downloadFileFromServer(fname: string): Observable<FileResponse>;
    getnetcdffilelistfromserver(measurementMode: boolean | undefined): Observable<FileResponse>;
    exportSampleCSVData(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse>;
    getAttachment(attachmentid: number): Observable<FileResponse>;
    getContent(contentid: number): Observable<ContentDTO>;
    getContentByType(contenttypeid: number, rowcount: number | null): Observable<ContentDTO[]>;
    getGeographySampleDataSummary(exportGeographySampleFilter: ExportGeographySampleFilterDTO): Observable<PolygonDataSummary>;
    getMeasurementData(searchFilter: GetMeasurementDataFilter): Observable<MeasurementDataDTO[]>;
    /**
     * @param sampleTypeId (optional) Sample type options:
     SeaWater = 1,
     Biota = 2,
     Sediment = 3,
     SuspendedMatter = 4
     * @param areaId (optional) String with a list of areas id. Example: '1,2,3,5'
     * @param areaName (optional) String with a list of areas name. Example: 'Indian Ocean'
     * @param samplingDateFrom (optional) Date time format yyyy-mm-ddThh:mm
     * @param samplingDateTo (optional) Date time format yyyy-mm-ddThh:mm
     * @param samplingDepthFrom (optional) Sampling depth 'from' range value Example: '0'
     * @param samplingDepthTo (optional) Sampling depth 'to' range value Example: '20'
     * @param samplingDepthCoreFrom (optional) Sampling depth core 'from' range value
     * @param samplingDepthCoreTo (optional) Sampling depth core 'from' range value
     * @param nuclideId (optional) String with a list of nuclide id. Example: '1,2,3,5'
     * @param samplingYear (optional) String with a list of years. Example: '1990,2001,2003,2005'
     * @param referenceId (optional) String with a list of reference id. Example: '1,2,3,4,6'
     * @param taxonname (optional) String with a list of taxon name. Example: 'Holothuria, Natator depressus'
     * @param bioGroup (optional) String with a list of bioGroup. Example: 'Fish'
     * @param bioGroupId (optional) String with a list of bioGroup id. Example: '1,2,3,5'
     * @param bodyPar (optional) String with a list of bodyPar id. Example: 'Flesh without bones'
     * @param bodyParId (optional) String with a list of bodyPar id. Example: '1,2,3,5'
     * @param sedimentType (optional) String with a list of sediment id. Example: '1,2,3,5'
     * @param filterPoreSize (optional) String with a list of filterPore size. Example: '1-51', '1', '-9'
     * @param shapeTypeId (optional) Shape Type. Possible options:
    IHO - 1
    FAO - 2
     * @param nuSymbol (optional) String with a list of nusymbol. Example: 'C-14', 'Nd-143/Nd-144', 'U-236'
     * @param unit (optional) String with a list of unit. Example: 'DELTA/mill', 'No units', 'atom/kg'
     */
    getMeasurementDataGet(sampleTypeId: number | null | undefined, areaId: string | null | undefined, areaName: string | null | undefined, samplingDateFrom: Date | null | undefined, samplingDateTo: Date | null | undefined, samplingDepthFrom: number | null | undefined, samplingDepthTo: number | null | undefined, samplingDepthCoreFrom: number | null | undefined, samplingDepthCoreTo: number | null | undefined, nuclideId: string | null | undefined, samplingYear: string | null | undefined, referenceId: string | null | undefined, taxonname: string | null | undefined, bioGroup: string | null | undefined, bioGroupId: string | null | undefined, bodyPar: string | null | undefined, bodyParId: string | null | undefined, sedimentType: string | null | undefined, filterPoreSize: string | null | undefined, shapeTypeId: number | null | undefined, nuSymbol: string | null | undefined, unit: string | null | undefined): Observable<ExportSample[]>;
    getMeasurementDataOptions(): Observable<MeasurementDataDTO[]>;
    getMeasurementDataMinimized(searchFilter: GetMeasurementDataFilter): Observable<MinimizedMeasurementData>;
    getHomePageData(): Observable<HomePageDataDTO[]>;
    getSampleDetails(sampleDetailSearch: SampleDetailSearchDTO): Observable<SampleDetailsDTO>;
    getSearchFilterContent(searchFilter: SearchFilterDTO): Observable<SearchFilterContentDTO>;
    search(searchFilter: SearchFilterDTO): Observable<SampleDataDTO[]>;
    getSampleData(searchFilter: SearchFilterDTO): Observable<SampleDataDTO[]>;
    getSampleDataMinimized(searchFilter: SearchFilterDTO): Observable<MinimizedSampleData>;
}

@Injectable({
    providedIn: 'root'
})
export class SearchClient implements ISearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    exportGeographySampleData(measurementMode: boolean | undefined, exportGeographySampleFilter: ExportGeographySampleFilterDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/exportgeographysampledata?";
        if (measurementMode === null)
            throw new Error("The parameter 'measurementMode' cannot be null.");
        else if (measurementMode !== undefined)
            url_ += "measurementMode=" + encodeURIComponent("" + measurementMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportGeographySampleFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGeographySampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGeographySampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportGeographySampleData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSampleData(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/exportsampledata?";
        if (measurementMode === null)
            throw new Error("The parameter 'measurementMode' cannot be null.");
        else if (measurementMode !== undefined)
            url_ += "measurementMode=" + encodeURIComponent("" + measurementMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportSampleFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSampleData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSampleDataFromDataSet(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/exportsampledatafromdataset?";
        if (measurementMode === null)
            throw new Error("The parameter 'measurementMode' cannot be null.");
        else if (measurementMode !== undefined)
            url_ += "measurementMode=" + encodeURIComponent("" + measurementMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportSampleFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSampleDataFromDataSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSampleDataFromDataSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSampleDataFromDataSet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSampleNetCDFData(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/exportsamplenetcdfdata?";
        if (measurementMode === null)
            throw new Error("The parameter 'measurementMode' cannot be null.");
        else if (measurementMode !== undefined)
            url_ += "measurementMode=" + encodeURIComponent("" + measurementMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportSampleFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSampleNetCDFData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSampleNetCDFData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSampleNetCDFData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFileFromServer(fname: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/downloadfile/{fname}";
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined.");
        url_ = url_.replace("{fname}", encodeURIComponent("" + fname));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileFromServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileFromServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFileFromServer(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getnetcdffilelistfromserver(measurementMode: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/getnetcdffilelistfromserver?";
        if (measurementMode === null)
            throw new Error("The parameter 'measurementMode' cannot be null.");
        else if (measurementMode !== undefined)
            url_ += "measurementMode=" + encodeURIComponent("" + measurementMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetnetcdffilelistfromserver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetnetcdffilelistfromserver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetnetcdffilelistfromserver(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSampleCSVData(measurementMode: boolean | undefined, exportSampleFilter: ExportSampleFilterDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/exportsamplecsvdata?";
        if (measurementMode === null)
            throw new Error("The parameter 'measurementMode' cannot be null.");
        else if (measurementMode !== undefined)
            url_ += "measurementMode=" + encodeURIComponent("" + measurementMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportSampleFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSampleCSVData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSampleCSVData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSampleCSVData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachment(attachmentid: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Search/getattachment/{attachmentid}";
        if (attachmentid === undefined || attachmentid === null)
            throw new Error("The parameter 'attachmentid' must be defined.");
        url_ = url_.replace("{attachmentid}", encodeURIComponent("" + attachmentid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContent(contentid: number): Observable<ContentDTO> {
        let url_ = this.baseUrl + "/api/Search/getcontent/{contentid}";
        if (contentid === undefined || contentid === null)
            throw new Error("The parameter 'contentid' must be defined.");
        url_ = url_.replace("{contentid}", encodeURIComponent("" + contentid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentDTO>;
        }));
    }

    protected processGetContent(response: HttpResponseBase): Observable<ContentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContentByType(contenttypeid: number, rowcount: number | null): Observable<ContentDTO[]> {
        let url_ = this.baseUrl + "/api/Search/getcontentbytype/{contenttypeid}/{rowcount}";
        if (contenttypeid === undefined || contenttypeid === null)
            throw new Error("The parameter 'contenttypeid' must be defined.");
        url_ = url_.replace("{contenttypeid}", encodeURIComponent("" + contenttypeid));
        if (rowcount === undefined || rowcount === null)
            throw new Error("The parameter 'rowcount' must be defined.");
        url_ = url_.replace("{rowcount}", encodeURIComponent("" + rowcount));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentDTO[]>;
        }));
    }

    protected processGetContentByType(response: HttpResponseBase): Observable<ContentDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGeographySampleDataSummary(exportGeographySampleFilter: ExportGeographySampleFilterDTO): Observable<PolygonDataSummary> {
        let url_ = this.baseUrl + "/api/Search/getgeographysampledatasummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportGeographySampleFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeographySampleDataSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeographySampleDataSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolygonDataSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolygonDataSummary>;
        }));
    }

    protected processGetGeographySampleDataSummary(response: HttpResponseBase): Observable<PolygonDataSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolygonDataSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMeasurementData(searchFilter: GetMeasurementDataFilter): Observable<MeasurementDataDTO[]> {
        let url_ = this.baseUrl + "/api/Search/getMeasurementData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementDataDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementDataDTO[]>;
        }));
    }

    protected processGetMeasurementData(response: HttpResponseBase): Observable<MeasurementDataDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementDataDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sampleTypeId (optional) Sample type options:
     SeaWater = 1,
     Biota = 2,
     Sediment = 3,
     SuspendedMatter = 4
     * @param areaId (optional) String with a list of areas id. Example: '1,2,3,5'
     * @param areaName (optional) String with a list of areas name. Example: 'Indian Ocean'
     * @param samplingDateFrom (optional) Date time format yyyy-mm-ddThh:mm
     * @param samplingDateTo (optional) Date time format yyyy-mm-ddThh:mm
     * @param samplingDepthFrom (optional) Sampling depth 'from' range value Example: '0'
     * @param samplingDepthTo (optional) Sampling depth 'to' range value Example: '20'
     * @param samplingDepthCoreFrom (optional) Sampling depth core 'from' range value
     * @param samplingDepthCoreTo (optional) Sampling depth core 'from' range value
     * @param nuclideId (optional) String with a list of nuclide id. Example: '1,2,3,5'
     * @param samplingYear (optional) String with a list of years. Example: '1990,2001,2003,2005'
     * @param referenceId (optional) String with a list of reference id. Example: '1,2,3,4,6'
     * @param taxonname (optional) String with a list of taxon name. Example: 'Holothuria, Natator depressus'
     * @param bioGroup (optional) String with a list of bioGroup. Example: 'Fish'
     * @param bioGroupId (optional) String with a list of bioGroup id. Example: '1,2,3,5'
     * @param bodyPar (optional) String with a list of bodyPar id. Example: 'Flesh without bones'
     * @param bodyParId (optional) String with a list of bodyPar id. Example: '1,2,3,5'
     * @param sedimentType (optional) String with a list of sediment id. Example: '1,2,3,5'
     * @param filterPoreSize (optional) String with a list of filterPore size. Example: '1-51', '1', '-9'
     * @param shapeTypeId (optional) Shape Type. Possible options:
    IHO - 1
    FAO - 2
     * @param nuSymbol (optional) String with a list of nusymbol. Example: 'C-14', 'Nd-143/Nd-144', 'U-236'
     * @param unit (optional) String with a list of unit. Example: 'DELTA/mill', 'No units', 'atom/kg'
     */
    getMeasurementDataGet(sampleTypeId: number | null | undefined, areaId: string | null | undefined, areaName: string | null | undefined, samplingDateFrom: Date | null | undefined, samplingDateTo: Date | null | undefined, samplingDepthFrom: number | null | undefined, samplingDepthTo: number | null | undefined, samplingDepthCoreFrom: number | null | undefined, samplingDepthCoreTo: number | null | undefined, nuclideId: string | null | undefined, samplingYear: string | null | undefined, referenceId: string | null | undefined, taxonname: string | null | undefined, bioGroup: string | null | undefined, bioGroupId: string | null | undefined, bodyPar: string | null | undefined, bodyParId: string | null | undefined, sedimentType: string | null | undefined, filterPoreSize: string | null | undefined, shapeTypeId: number | null | undefined, nuSymbol: string | null | undefined, unit: string | null | undefined): Observable<ExportSample[]> {
        let url_ = this.baseUrl + "/api/Search/getMeasurementData?";
        if (sampleTypeId !== undefined && sampleTypeId !== null)
            url_ += "SampleTypeId=" + encodeURIComponent("" + sampleTypeId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        if (areaName !== undefined && areaName !== null)
            url_ += "AreaName=" + encodeURIComponent("" + areaName) + "&";
        if (samplingDateFrom !== undefined && samplingDateFrom !== null)
            url_ += "SamplingDateFrom=" + encodeURIComponent(samplingDateFrom ? "" + samplingDateFrom.toISOString() : "") + "&";
        if (samplingDateTo !== undefined && samplingDateTo !== null)
            url_ += "SamplingDateTo=" + encodeURIComponent(samplingDateTo ? "" + samplingDateTo.toISOString() : "") + "&";
        if (samplingDepthFrom !== undefined && samplingDepthFrom !== null)
            url_ += "SamplingDepthFrom=" + encodeURIComponent("" + samplingDepthFrom) + "&";
        if (samplingDepthTo !== undefined && samplingDepthTo !== null)
            url_ += "SamplingDepthTo=" + encodeURIComponent("" + samplingDepthTo) + "&";
        if (samplingDepthCoreFrom !== undefined && samplingDepthCoreFrom !== null)
            url_ += "SamplingDepthCoreFrom=" + encodeURIComponent("" + samplingDepthCoreFrom) + "&";
        if (samplingDepthCoreTo !== undefined && samplingDepthCoreTo !== null)
            url_ += "SamplingDepthCoreTo=" + encodeURIComponent("" + samplingDepthCoreTo) + "&";
        if (nuclideId !== undefined && nuclideId !== null)
            url_ += "NuclideId=" + encodeURIComponent("" + nuclideId) + "&";
        if (samplingYear !== undefined && samplingYear !== null)
            url_ += "SamplingYear=" + encodeURIComponent("" + samplingYear) + "&";
        if (referenceId !== undefined && referenceId !== null)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (taxonname !== undefined && taxonname !== null)
            url_ += "Taxonname=" + encodeURIComponent("" + taxonname) + "&";
        if (bioGroup !== undefined && bioGroup !== null)
            url_ += "BioGroup=" + encodeURIComponent("" + bioGroup) + "&";
        if (bioGroupId !== undefined && bioGroupId !== null)
            url_ += "BioGroupId=" + encodeURIComponent("" + bioGroupId) + "&";
        if (bodyPar !== undefined && bodyPar !== null)
            url_ += "BodyPar=" + encodeURIComponent("" + bodyPar) + "&";
        if (bodyParId !== undefined && bodyParId !== null)
            url_ += "BodyParId=" + encodeURIComponent("" + bodyParId) + "&";
        if (sedimentType !== undefined && sedimentType !== null)
            url_ += "SedimentType=" + encodeURIComponent("" + sedimentType) + "&";
        if (filterPoreSize !== undefined && filterPoreSize !== null)
            url_ += "FilterPoreSize=" + encodeURIComponent("" + filterPoreSize) + "&";
        if (shapeTypeId !== undefined && shapeTypeId !== null)
            url_ += "ShapeTypeId=" + encodeURIComponent("" + shapeTypeId) + "&";
        if (nuSymbol !== undefined && nuSymbol !== null)
            url_ += "NuSymbol=" + encodeURIComponent("" + nuSymbol) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "Unit=" + encodeURIComponent("" + unit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementDataGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementDataGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportSample[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportSample[]>;
        }));
    }

    protected processGetMeasurementDataGet(response: HttpResponseBase): Observable<ExportSample[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportSample.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMeasurementDataOptions(): Observable<MeasurementDataDTO[]> {
        let url_ = this.baseUrl + "/api/Search/getMeasurementData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementDataOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementDataOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementDataDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementDataDTO[]>;
        }));
    }

    protected processGetMeasurementDataOptions(response: HttpResponseBase): Observable<MeasurementDataDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementDataDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMeasurementDataMinimized(searchFilter: GetMeasurementDataFilter): Observable<MinimizedMeasurementData> {
        let url_ = this.baseUrl + "/api/Search/getMeasurementData-minimized";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementDataMinimized(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementDataMinimized(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimizedMeasurementData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimizedMeasurementData>;
        }));
    }

    protected processGetMeasurementDataMinimized(response: HttpResponseBase): Observable<MinimizedMeasurementData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimizedMeasurementData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHomePageData(): Observable<HomePageDataDTO[]> {
        let url_ = this.baseUrl + "/api/Search/getHomePageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomePageData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomePageData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomePageDataDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomePageDataDTO[]>;
        }));
    }

    protected processGetHomePageData(response: HttpResponseBase): Observable<HomePageDataDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HomePageDataDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSampleDetails(sampleDetailSearch: SampleDetailSearchDTO): Observable<SampleDetailsDTO> {
        let url_ = this.baseUrl + "/api/Search/getSampleDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sampleDetailSearch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleDetailsDTO>;
        }));
    }

    protected processGetSampleDetails(response: HttpResponseBase): Observable<SampleDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSearchFilterContent(searchFilter: SearchFilterDTO): Observable<SearchFilterContentDTO> {
        let url_ = this.baseUrl + "/api/Search/getSearchFilterContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchFilterContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchFilterContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFilterContentDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFilterContentDTO>;
        }));
    }

    protected processGetSearchFilterContent(response: HttpResponseBase): Observable<SearchFilterContentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFilterContentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(searchFilter: SearchFilterDTO): Observable<SampleDataDTO[]> {
        let url_ = this.baseUrl + "/api/Search/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleDataDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleDataDTO[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SampleDataDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SampleDataDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSampleData(searchFilter: SearchFilterDTO): Observable<SampleDataDTO[]> {
        let url_ = this.baseUrl + "/api/Search/getsampledata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleDataDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleDataDTO[]>;
        }));
    }

    protected processGetSampleData(response: HttpResponseBase): Observable<SampleDataDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SampleDataDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSampleDataMinimized(searchFilter: SearchFilterDTO): Observable<MinimizedSampleData> {
        let url_ = this.baseUrl + "/api/Search/getsampledata-minimized";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleDataMinimized(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleDataMinimized(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimizedSampleData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimizedSampleData>;
        }));
    }

    protected processGetSampleDataMinimized(response: HttpResponseBase): Observable<MinimizedSampleData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimizedSampleData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISedTypeLookupClient {
    get(id: number): Observable<SedTypeDTO>;
    getAll(): Observable<SedTypeDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SedTypeLookupClient implements ISedTypeLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<SedTypeDTO> {
        let url_ = this.baseUrl + "/api/SedTypeLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SedTypeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SedTypeDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SedTypeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SedTypeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<SedTypeDTO[]> {
        let url_ = this.baseUrl + "/api/SedTypeLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SedTypeDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SedTypeDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SedTypeDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SedTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISpeciesLookupClient {
    get(id: number): Observable<SpeciesDTO>;
    getAll(): Observable<SpeciesDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SpeciesLookupClient implements ISpeciesLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<SpeciesDTO> {
        let url_ = this.baseUrl + "/api/SpeciesLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpeciesDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpeciesDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SpeciesDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpeciesDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<SpeciesDTO[]> {
        let url_ = this.baseUrl + "/api/SpeciesLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpeciesDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpeciesDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SpeciesDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpeciesDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUnitLookupClient {
    get(id: number): Observable<UnitDTO>;
    getAll(): Observable<UnitDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UnitLookupClient implements IUnitLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<UnitDTO> {
        let url_ = this.baseUrl + "/api/UnitLookup/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UnitDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<UnitDTO[]> {
        let url_ = this.baseUrl + "/api/UnitLookup/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UnitDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVersionClient {
    get(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class VersionClient implements IVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class SampleAreaLookup implements ISampleAreaLookup {
    areaId?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: ISampleAreaLookup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SampleAreaLookup {
        data = typeof data === 'object' ? data : {};
        let result = new SampleAreaLookup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISampleAreaLookup {
    areaId?: string | undefined;
    displayName?: string | undefined;
}

export class BioGroupDTO implements IBioGroupDTO {
    bioGroup_Id?: number;
    bioGroup?: string;
    species?: string;

    constructor(data?: IBioGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bioGroup_Id = _data["bioGroup_Id"];
            this.bioGroup = _data["bioGroup"];
            this.species = _data["species"];
        }
    }

    static fromJS(data: any): BioGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BioGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bioGroup_Id"] = this.bioGroup_Id;
        data["bioGroup"] = this.bioGroup;
        data["species"] = this.species;
        return data;
    }
}

export interface IBioGroupDTO {
    bioGroup_Id?: number;
    bioGroup?: string;
    species?: string;
}

export class BodyParDTO implements IBodyParDTO {
    bodyPar_Id?: number;
    bodyPar?: string;

    constructor(data?: IBodyParDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bodyPar_Id = _data["bodyPar_Id"];
            this.bodyPar = _data["bodyPar"];
        }
    }

    static fromJS(data: any): BodyParDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BodyParDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodyPar_Id"] = this.bodyPar_Id;
        data["bodyPar"] = this.bodyPar;
        return data;
    }
}

export interface IBodyParDTO {
    bodyPar_Id?: number;
    bodyPar?: string;
}

export class CounmetDTO implements ICounmetDTO {
    counmet_Id?: number;
    counmet?: string;
    code?: string;

    constructor(data?: ICounmetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counmet_Id = _data["counmet_Id"];
            this.counmet = _data["counmet"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CounmetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CounmetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counmet_Id"] = this.counmet_Id;
        data["counmet"] = this.counmet;
        data["code"] = this.code;
        return data;
    }
}

export interface ICounmetDTO {
    counmet_Id?: number;
    counmet?: string;
    code?: string;
}

export class DrymetDTO implements IDrymetDTO {
    drymet_Id?: number;
    drymet?: string;
    code?: string;

    constructor(data?: IDrymetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drymet_Id = _data["drymet_Id"];
            this.drymet = _data["drymet"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): DrymetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DrymetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drymet_Id"] = this.drymet_Id;
        data["drymet"] = this.drymet;
        data["code"] = this.code;
        return data;
    }
}

export interface IDrymetDTO {
    drymet_Id?: number;
    drymet?: string;
    code?: string;
}

export class LabDTO implements ILabDTO {
    lab_Id?: number;
    lab_Abb?: string;
    lab?: string;
    addr_1?: string;
    addr_2?: string;
    twn_zip?: string;
    country?: string;
    tel?: string;
    e_mail?: string;
    fax?: string;
    note?: string;

    constructor(data?: ILabDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lab_Id = _data["lab_Id"];
            this.lab_Abb = _data["lab_Abb"];
            this.lab = _data["lab"];
            this.addr_1 = _data["addr_1"];
            this.addr_2 = _data["addr_2"];
            this.twn_zip = _data["twn_zip"];
            this.country = _data["country"];
            this.tel = _data["tel"];
            this.e_mail = _data["e_mail"];
            this.fax = _data["fax"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): LabDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LabDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lab_Id"] = this.lab_Id;
        data["lab_Abb"] = this.lab_Abb;
        data["lab"] = this.lab;
        data["addr_1"] = this.addr_1;
        data["addr_2"] = this.addr_2;
        data["twn_zip"] = this.twn_zip;
        data["country"] = this.country;
        data["tel"] = this.tel;
        data["e_mail"] = this.e_mail;
        data["fax"] = this.fax;
        data["note"] = this.note;
        return data;
    }
}

export interface ILabDTO {
    lab_Id?: number;
    lab_Abb?: string;
    lab?: string;
    addr_1?: string;
    addr_2?: string;
    twn_zip?: string;
    country?: string;
    tel?: string;
    e_mail?: string;
    fax?: string;
    note?: string;
}

export class NuclideDTO implements INuclideDTO {
    nuclide_Id?: number;
    nuclide?: string;
    atomicnb?: number | undefined;
    massnb?: number | undefined;
    nusymbol?: string;
    half_life?: number;
    hl_unit?: string;

    constructor(data?: INuclideDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nuclide_Id = _data["nuclide_Id"];
            this.nuclide = _data["nuclide"];
            this.atomicnb = _data["atomicnb"];
            this.massnb = _data["massnb"];
            this.nusymbol = _data["nusymbol"];
            this.half_life = _data["half_life"];
            this.hl_unit = _data["hl_unit"];
        }
    }

    static fromJS(data: any): NuclideDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NuclideDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nuclide_Id"] = this.nuclide_Id;
        data["nuclide"] = this.nuclide;
        data["atomicnb"] = this.atomicnb;
        data["massnb"] = this.massnb;
        data["nusymbol"] = this.nusymbol;
        data["half_life"] = this.half_life;
        data["hl_unit"] = this.hl_unit;
        return data;
    }
}

export interface INuclideDTO {
    nuclide_Id?: number;
    nuclide?: string;
    atomicnb?: number | undefined;
    massnb?: number | undefined;
    nusymbol?: string;
    half_life?: number;
    hl_unit?: string;
}

export class PrepmetDTO implements IPrepmetDTO {
    prepmet_Id?: number;
    prepmet?: string;
    code?: string;
    type_1?: number;
    type_2?: number | undefined;
    type_3?: number | undefined;
    type_4?: number | undefined;

    constructor(data?: IPrepmetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prepmet_Id = _data["prepmet_Id"];
            this.prepmet = _data["prepmet"];
            this.code = _data["code"];
            this.type_1 = _data["type_1"];
            this.type_2 = _data["type_2"];
            this.type_3 = _data["type_3"];
            this.type_4 = _data["type_4"];
        }
    }

    static fromJS(data: any): PrepmetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrepmetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prepmet_Id"] = this.prepmet_Id;
        data["prepmet"] = this.prepmet;
        data["code"] = this.code;
        data["type_1"] = this.type_1;
        data["type_2"] = this.type_2;
        data["type_3"] = this.type_3;
        data["type_4"] = this.type_4;
        return data;
    }
}

export interface IPrepmetDTO {
    prepmet_Id?: number;
    prepmet?: string;
    code?: string;
    type_1?: number;
    type_2?: number | undefined;
    type_3?: number | undefined;
    type_4?: number | undefined;
}

export class RefLookup implements IRefLookup {
    refId?: number;
    displayText?: string | undefined;

    constructor(data?: IRefLookup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refId = _data["refId"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): RefLookup {
        data = typeof data === 'object' ? data : {};
        let result = new RefLookup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IRefLookup {
    refId?: number;
    displayText?: string | undefined;
}

export class SampmetDTO implements ISampmetDTO {
    sampmet_Id?: number;
    sampmet?: string;
    code?: string;
    type_1?: number;
    type_2?: number | undefined;
    type_3?: number | undefined;
    type_4?: number | undefined;

    constructor(data?: ISampmetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampmet_Id = _data["sampmet_Id"];
            this.sampmet = _data["sampmet"];
            this.code = _data["code"];
            this.type_1 = _data["type_1"];
            this.type_2 = _data["type_2"];
            this.type_3 = _data["type_3"];
            this.type_4 = _data["type_4"];
        }
    }

    static fromJS(data: any): SampmetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SampmetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampmet_Id"] = this.sampmet_Id;
        data["sampmet"] = this.sampmet;
        data["code"] = this.code;
        data["type_1"] = this.type_1;
        data["type_2"] = this.type_2;
        data["type_3"] = this.type_3;
        data["type_4"] = this.type_4;
        return data;
    }
}

export interface ISampmetDTO {
    sampmet_Id?: number;
    sampmet?: string;
    code?: string;
    type_1?: number;
    type_2?: number | undefined;
    type_3?: number | undefined;
    type_4?: number | undefined;
}

export class SampTypeDTO implements ISampTypeDTO {
    sampType_Id?: number;
    sampType?: string;
    ordlist?: number;

    constructor(data?: ISampTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampType_Id = _data["sampType_Id"];
            this.sampType = _data["sampType"];
            this.ordlist = _data["ordlist"];
        }
    }

    static fromJS(data: any): SampTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SampTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampType_Id"] = this.sampType_Id;
        data["sampType"] = this.sampType;
        data["ordlist"] = this.ordlist;
        return data;
    }
}

export interface ISampTypeDTO {
    sampType_Id?: number;
    sampType?: string;
    ordlist?: number;
}

export class ExportGeographySampleFilterDTO implements IExportGeographySampleFilterDTO {
    exportColumns?: string[];
    filterValues?: SearchFilterDTO;
    geoSpatialString?: string;
    geoTypeId?: number;
    sampleId?: number;

    constructor(data?: IExportGeographySampleFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exportColumns"])) {
                this.exportColumns = [] as any;
                for (let item of _data["exportColumns"])
                    this.exportColumns!.push(item);
            }
            this.filterValues = _data["filterValues"] ? SearchFilterDTO.fromJS(_data["filterValues"]) : <any>undefined;
            this.geoSpatialString = _data["geoSpatialString"];
            this.geoTypeId = _data["geoTypeId"];
            this.sampleId = _data["sampleId"];
        }
    }

    static fromJS(data: any): ExportGeographySampleFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGeographySampleFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exportColumns)) {
            data["exportColumns"] = [];
            for (let item of this.exportColumns)
                data["exportColumns"].push(item);
        }
        data["filterValues"] = this.filterValues ? this.filterValues.toJSON() : <any>undefined;
        data["geoSpatialString"] = this.geoSpatialString;
        data["geoTypeId"] = this.geoTypeId;
        data["sampleId"] = this.sampleId;
        return data;
    }
}

export interface IExportGeographySampleFilterDTO {
    exportColumns?: string[];
    filterValues?: SearchFilterDTO;
    geoSpatialString?: string;
    geoTypeId?: number;
    sampleId?: number;
}

export class SearchFilterDTO implements ISearchFilterDTO {
    areaId?: string;
    bioGroup?: string;
    bodyPar?: string;
    cacheKey?: string;
    filterPoreSize?: string;
    lastUpdate?: string;
    nuclideId?: string;
    reference?: string;
    reset?: boolean;
    sampleTypeId?: number;
    samplingDepthCoreFrom?: number | undefined;
    samplingDepthCoreTo?: number | undefined;
    samplingDepthFrom?: number | undefined;
    samplingDepthTo?: number | undefined;
    samplingYear?: string;
    sedimentType?: string;
    shapeTypeId?: number;
    subAreaId?: string;
    taxonname?: string;

    constructor(data?: ISearchFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
            this.bioGroup = _data["bioGroup"];
            this.bodyPar = _data["bodyPar"];
            this.cacheKey = _data["cacheKey"];
            this.filterPoreSize = _data["filterPoreSize"];
            this.lastUpdate = _data["lastUpdate"];
            this.nuclideId = _data["nuclideId"];
            this.reference = _data["reference"];
            this.reset = _data["reset"];
            this.sampleTypeId = _data["sampleTypeId"];
            this.samplingDepthCoreFrom = _data["samplingDepthCoreFrom"];
            this.samplingDepthCoreTo = _data["samplingDepthCoreTo"];
            this.samplingDepthFrom = _data["samplingDepthFrom"];
            this.samplingDepthTo = _data["samplingDepthTo"];
            this.samplingYear = _data["samplingYear"];
            this.sedimentType = _data["sedimentType"];
            this.shapeTypeId = _data["shapeTypeId"];
            this.subAreaId = _data["subAreaId"];
            this.taxonname = _data["taxonname"];
        }
    }

    static fromJS(data: any): SearchFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["bioGroup"] = this.bioGroup;
        data["bodyPar"] = this.bodyPar;
        data["cacheKey"] = this.cacheKey;
        data["filterPoreSize"] = this.filterPoreSize;
        data["lastUpdate"] = this.lastUpdate;
        data["nuclideId"] = this.nuclideId;
        data["reference"] = this.reference;
        data["reset"] = this.reset;
        data["sampleTypeId"] = this.sampleTypeId;
        data["samplingDepthCoreFrom"] = this.samplingDepthCoreFrom;
        data["samplingDepthCoreTo"] = this.samplingDepthCoreTo;
        data["samplingDepthFrom"] = this.samplingDepthFrom;
        data["samplingDepthTo"] = this.samplingDepthTo;
        data["samplingYear"] = this.samplingYear;
        data["sedimentType"] = this.sedimentType;
        data["shapeTypeId"] = this.shapeTypeId;
        data["subAreaId"] = this.subAreaId;
        data["taxonname"] = this.taxonname;
        return data;
    }
}

export interface ISearchFilterDTO {
    areaId?: string;
    bioGroup?: string;
    bodyPar?: string;
    cacheKey?: string;
    filterPoreSize?: string;
    lastUpdate?: string;
    nuclideId?: string;
    reference?: string;
    reset?: boolean;
    sampleTypeId?: number;
    samplingDepthCoreFrom?: number | undefined;
    samplingDepthCoreTo?: number | undefined;
    samplingDepthFrom?: number | undefined;
    samplingDepthTo?: number | undefined;
    samplingYear?: string;
    sedimentType?: string;
    shapeTypeId?: number;
    subAreaId?: string;
    taxonname?: string;
}

export class ExportSampleFilterDTO implements IExportSampleFilterDTO {
    exportColumns?: string[];
    searchFilter?: SearchFilterDTO;

    constructor(data?: IExportSampleFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exportColumns"])) {
                this.exportColumns = [] as any;
                for (let item of _data["exportColumns"])
                    this.exportColumns!.push(item);
            }
            this.searchFilter = _data["searchFilter"] ? SearchFilterDTO.fromJS(_data["searchFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportSampleFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSampleFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exportColumns)) {
            data["exportColumns"] = [];
            for (let item of this.exportColumns)
                data["exportColumns"].push(item);
        }
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExportSampleFilterDTO {
    exportColumns?: string[];
    searchFilter?: SearchFilterDTO;
}

export class ContentDTO implements IContentDTO {
    attachments?: ContentAttachmentDTO[];
    content?: string;
    contentId?: number;
    contentStatusId?: number;
    contentTypeId?: number;
    contentCategoryId?: number | undefined;
    createdBy?: string;
    creationDate?: Date;
    sortOrder?: number;
    title?: string;
    updatedBy?: string;
    updatedOn?: Date | undefined;
    contentCategory?: string;

    constructor(data?: IContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ContentAttachmentDTO.fromJS(item));
            }
            this.content = _data["content"];
            this.contentId = _data["contentId"];
            this.contentStatusId = _data["contentStatusId"];
            this.contentTypeId = _data["contentTypeId"];
            this.contentCategoryId = _data["contentCategoryId"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.sortOrder = _data["sortOrder"];
            this.title = _data["title"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.contentCategory = _data["contentCategory"];
        }
    }

    static fromJS(data: any): ContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["content"] = this.content;
        data["contentId"] = this.contentId;
        data["contentStatusId"] = this.contentStatusId;
        data["contentTypeId"] = this.contentTypeId;
        data["contentCategoryId"] = this.contentCategoryId;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["sortOrder"] = this.sortOrder;
        data["title"] = this.title;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["contentCategory"] = this.contentCategory;
        return data;
    }
}

export interface IContentDTO {
    attachments?: ContentAttachmentDTO[];
    content?: string;
    contentId?: number;
    contentStatusId?: number;
    contentTypeId?: number;
    contentCategoryId?: number | undefined;
    createdBy?: string;
    creationDate?: Date;
    sortOrder?: number;
    title?: string;
    updatedBy?: string;
    updatedOn?: Date | undefined;
    contentCategory?: string;
}

export class ContentAttachmentDTO implements IContentAttachmentDTO {
    attachmentContent?: string;
    contentAttachmentId?: number;
    contentAttachmentTypeId?: number;
    contentId?: number;
    fileName?: string;
    fileType?: string;
    isActive?: boolean;

    constructor(data?: IContentAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentContent = _data["attachmentContent"];
            this.contentAttachmentId = _data["contentAttachmentId"];
            this.contentAttachmentTypeId = _data["contentAttachmentTypeId"];
            this.contentId = _data["contentId"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ContentAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentContent"] = this.attachmentContent;
        data["contentAttachmentId"] = this.contentAttachmentId;
        data["contentAttachmentTypeId"] = this.contentAttachmentTypeId;
        data["contentId"] = this.contentId;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IContentAttachmentDTO {
    attachmentContent?: string;
    contentAttachmentId?: number;
    contentAttachmentTypeId?: number;
    contentId?: number;
    fileName?: string;
    fileType?: string;
    isActive?: boolean;
}

export class PolygonDataSummary implements IPolygonDataSummary {
    measureCount?: number;
    sampleCount?: number;

    constructor(data?: IPolygonDataSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measureCount = _data["measureCount"];
            this.sampleCount = _data["sampleCount"];
        }
    }

    static fromJS(data: any): PolygonDataSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PolygonDataSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measureCount"] = this.measureCount;
        data["sampleCount"] = this.sampleCount;
        return data;
    }
}

export interface IPolygonDataSummary {
    measureCount?: number;
    sampleCount?: number;
}

export class MeasurementDataDTO implements IMeasurementDataDTO {
    activity?: number | undefined;
    begPeriod?: Date | undefined;
    detection?: string | undefined;
    endPeriod?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    nuSymbol?: string | undefined;
    profileId?: string | undefined;
    refId?: number;
    sampleId?: number;
    sampleType?: string | undefined;
    samplingDepth?: number | undefined;
    unit?: string | undefined;
    activityCorr?: number | undefined;
    uncertanityCorr?: number | undefined;
    unitCorr?: string | undefined;
    nuclideId?: number;

    constructor(data?: IMeasurementDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"];
            this.begPeriod = _data["begPeriod"] ? new Date(_data["begPeriod"].toString()) : <any>undefined;
            this.detection = _data["detection"];
            this.endPeriod = _data["endPeriod"] ? new Date(_data["endPeriod"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.nuSymbol = _data["nuSymbol"];
            this.profileId = _data["profileId"];
            this.refId = _data["refId"];
            this.sampleId = _data["sampleId"];
            this.sampleType = _data["sampleType"];
            this.samplingDepth = _data["samplingDepth"];
            this.unit = _data["unit"];
            this.activityCorr = _data["activityCorr"];
            this.uncertanityCorr = _data["uncertanityCorr"];
            this.unitCorr = _data["unitCorr"];
            this.nuclideId = _data["nuclideId"];
        }
    }

    static fromJS(data: any): MeasurementDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["begPeriod"] = this.begPeriod ? this.begPeriod.toISOString() : <any>undefined;
        data["detection"] = this.detection;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["nuSymbol"] = this.nuSymbol;
        data["profileId"] = this.profileId;
        data["refId"] = this.refId;
        data["sampleId"] = this.sampleId;
        data["sampleType"] = this.sampleType;
        data["samplingDepth"] = this.samplingDepth;
        data["unit"] = this.unit;
        data["activityCorr"] = this.activityCorr;
        data["uncertanityCorr"] = this.uncertanityCorr;
        data["unitCorr"] = this.unitCorr;
        data["nuclideId"] = this.nuclideId;
        return data;
    }
}

export interface IMeasurementDataDTO {
    activity?: number | undefined;
    begPeriod?: Date | undefined;
    detection?: string | undefined;
    endPeriod?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    nuSymbol?: string | undefined;
    profileId?: string | undefined;
    refId?: number;
    sampleId?: number;
    sampleType?: string | undefined;
    samplingDepth?: number | undefined;
    unit?: string | undefined;
    activityCorr?: number | undefined;
    uncertanityCorr?: number | undefined;
    unitCorr?: string | undefined;
    nuclideId?: number;
}

/** Filter */
export class GetMeasurementDataFilter implements IGetMeasurementDataFilter {
    /** Sample type options:
 SeaWater = 1,
 Biota = 2,
 Sediment = 3,
 SuspendedMatter = 4 */
    sampleTypeId?: number | undefined;
    /** String with a list of areas id. Example: '1,2,3,5' */
    areaId?: string | undefined;
    /** String with a list of areas name. Example: 'Indian Ocean' */
    areaName?: string | undefined;
    /** Date time format yyyy-mm-ddThh:mm */
    samplingDateFrom?: Date | undefined;
    /** Date time format yyyy-mm-ddThh:mm */
    samplingDateTo?: Date | undefined;
    /** Sampling depth 'from' range value Example: '0' */
    samplingDepthFrom?: number | undefined;
    /** Sampling depth 'to' range value Example: '20' */
    samplingDepthTo?: number | undefined;
    /** Sampling depth core 'from' range value */
    samplingDepthCoreFrom?: number | undefined;
    /** Sampling depth core 'from' range value */
    samplingDepthCoreTo?: number | undefined;
    /** String with a list of nuclide id. Example: '1,2,3,5' */
    nuclideId?: string | undefined;
    /** String with a list of years. Example: '1990,2001,2003,2005' */
    samplingYear?: string | undefined;
    /** String with a list of reference id. Example: '1,2,3,4,6' */
    referenceId?: string | undefined;
    /** String with a list of taxon name. Example: 'Holothuria, Natator depressus' */
    taxonname?: string | undefined;
    /** String with a list of bioGroup. Example: 'Fish' */
    bioGroup?: string | undefined;
    /** String with a list of bioGroup id. Example: '1,2,3,5' */
    bioGroupId?: string | undefined;
    /** String with a list of bodyPar id. Example: 'Flesh without bones' */
    bodyPar?: string | undefined;
    /** String with a list of bodyPar id. Example: '1,2,3,5' */
    bodyParId?: string | undefined;
    /** String with a list of sediment id. Example: '1,2,3,5' */
    sedimentType?: string | undefined;
    /** String with a list of filterPore size. Example: '1-51', '1', '-9' */
    filterPoreSize?: string | undefined;
    /** Shape Type. Possible options:
IHO - 1
FAO - 2 */
    shapeTypeId?: number | undefined;
    /** String with a list of nusymbol. Example: 'C-14', 'Nd-143/Nd-144', 'U-236' */
    nuSymbol?: string | undefined;
    /** String with a list of unit. Example: 'DELTA/mill', 'No units', 'atom/kg' */
    unit?: string | undefined;

    constructor(data?: IGetMeasurementDataFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleTypeId = _data["sampleTypeId"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.samplingDateFrom = _data["samplingDateFrom"] ? new Date(_data["samplingDateFrom"].toString()) : <any>undefined;
            this.samplingDateTo = _data["samplingDateTo"] ? new Date(_data["samplingDateTo"].toString()) : <any>undefined;
            this.samplingDepthFrom = _data["samplingDepthFrom"];
            this.samplingDepthTo = _data["samplingDepthTo"];
            this.samplingDepthCoreFrom = _data["samplingDepthCoreFrom"];
            this.samplingDepthCoreTo = _data["samplingDepthCoreTo"];
            this.nuclideId = _data["nuclideId"];
            this.samplingYear = _data["samplingYear"];
            this.referenceId = _data["referenceId"];
            this.taxonname = _data["taxonname"];
            this.bioGroup = _data["bioGroup"];
            this.bioGroupId = _data["bioGroupId"];
            this.bodyPar = _data["bodyPar"];
            this.bodyParId = _data["bodyParId"];
            this.sedimentType = _data["sedimentType"];
            this.filterPoreSize = _data["filterPoreSize"];
            this.shapeTypeId = _data["shapeTypeId"];
            this.nuSymbol = _data["nuSymbol"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): GetMeasurementDataFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementDataFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleTypeId"] = this.sampleTypeId;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["samplingDateFrom"] = this.samplingDateFrom ? this.samplingDateFrom.toISOString() : <any>undefined;
        data["samplingDateTo"] = this.samplingDateTo ? this.samplingDateTo.toISOString() : <any>undefined;
        data["samplingDepthFrom"] = this.samplingDepthFrom;
        data["samplingDepthTo"] = this.samplingDepthTo;
        data["samplingDepthCoreFrom"] = this.samplingDepthCoreFrom;
        data["samplingDepthCoreTo"] = this.samplingDepthCoreTo;
        data["nuclideId"] = this.nuclideId;
        data["samplingYear"] = this.samplingYear;
        data["referenceId"] = this.referenceId;
        data["taxonname"] = this.taxonname;
        data["bioGroup"] = this.bioGroup;
        data["bioGroupId"] = this.bioGroupId;
        data["bodyPar"] = this.bodyPar;
        data["bodyParId"] = this.bodyParId;
        data["sedimentType"] = this.sedimentType;
        data["filterPoreSize"] = this.filterPoreSize;
        data["shapeTypeId"] = this.shapeTypeId;
        data["nuSymbol"] = this.nuSymbol;
        data["unit"] = this.unit;
        return data;
    }
}

/** Filter */
export interface IGetMeasurementDataFilter {
    /** Sample type options:
 SeaWater = 1,
 Biota = 2,
 Sediment = 3,
 SuspendedMatter = 4 */
    sampleTypeId?: number | undefined;
    /** String with a list of areas id. Example: '1,2,3,5' */
    areaId?: string | undefined;
    /** String with a list of areas name. Example: 'Indian Ocean' */
    areaName?: string | undefined;
    /** Date time format yyyy-mm-ddThh:mm */
    samplingDateFrom?: Date | undefined;
    /** Date time format yyyy-mm-ddThh:mm */
    samplingDateTo?: Date | undefined;
    /** Sampling depth 'from' range value Example: '0' */
    samplingDepthFrom?: number | undefined;
    /** Sampling depth 'to' range value Example: '20' */
    samplingDepthTo?: number | undefined;
    /** Sampling depth core 'from' range value */
    samplingDepthCoreFrom?: number | undefined;
    /** Sampling depth core 'from' range value */
    samplingDepthCoreTo?: number | undefined;
    /** String with a list of nuclide id. Example: '1,2,3,5' */
    nuclideId?: string | undefined;
    /** String with a list of years. Example: '1990,2001,2003,2005' */
    samplingYear?: string | undefined;
    /** String with a list of reference id. Example: '1,2,3,4,6' */
    referenceId?: string | undefined;
    /** String with a list of taxon name. Example: 'Holothuria, Natator depressus' */
    taxonname?: string | undefined;
    /** String with a list of bioGroup. Example: 'Fish' */
    bioGroup?: string | undefined;
    /** String with a list of bioGroup id. Example: '1,2,3,5' */
    bioGroupId?: string | undefined;
    /** String with a list of bodyPar id. Example: 'Flesh without bones' */
    bodyPar?: string | undefined;
    /** String with a list of bodyPar id. Example: '1,2,3,5' */
    bodyParId?: string | undefined;
    /** String with a list of sediment id. Example: '1,2,3,5' */
    sedimentType?: string | undefined;
    /** String with a list of filterPore size. Example: '1-51', '1', '-9' */
    filterPoreSize?: string | undefined;
    /** Shape Type. Possible options:
IHO - 1
FAO - 2 */
    shapeTypeId?: number | undefined;
    /** String with a list of nusymbol. Example: 'C-14', 'Nd-143/Nd-144', 'U-236' */
    nuSymbol?: string | undefined;
    /** String with a list of unit. Example: 'DELTA/mill', 'No units', 'atom/kg' */
    unit?: string | undefined;
}

export class ExportSample implements IExportSample {
    activity?: number | undefined;
    areaId?: string | undefined;
    areaName?: string | undefined;
    begPeriod?: Date;
    bioGroup?: string | undefined;
    bodyPar?: string | undefined;
    bodyParId?: number;
    counmet?: string | undefined;
    detection?: string | undefined;
    displayText?: string | undefined;
    drymet?: string | undefined;
    drywt?: number | undefined;
    endPeriod?: Date | undefined;
    filtered?: string | undefined;
    filtpore?: string | undefined;
    frequency?: number | undefined;
    lab?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    measureNote?: string | undefined;
    nuclideId?: number;
    nuSymbol?: string | undefined;
    percentwt?: number | undefined;
    prepmet?: string | undefined;
    profileId?: string | undefined;
    rangeLow?: number | undefined;
    rangeUp?: number | undefined;
    refId?: number;
    refFulltext?: string | undefined;
    refNote?: string | undefined;
    salinity?: number | undefined;
    samparea?: number | undefined;
    sampleDepth?: number | undefined;
    sampleId?: number;
    sampleLabCode?: string | undefined;
    samplingYear?: number;
    sampmet?: string | undefined;
    sampNote?: string | undefined;
    sampType?: string | undefined;
    sampTypeId?: number;
    sedRepName?: string | undefined;
    sedType?: string | undefined;
    sedTypeId?: number;
    shapeTypeId?: number;
    sliceDown?: number | undefined;
    sliceUp?: number | undefined;
    speciesId?: number;
    station?: string | undefined;
    taxonDbUrl?: string | undefined;
    taxonName?: string | undefined;
    taxonRank?: string | undefined;
    taxonRepName?: string | undefined;
    temperature?: number | undefined;
    totalDepth?: number | undefined;
    transactId?: string | undefined;
    uncertanity?: number | undefined;
    unit?: string | undefined;
    unitId?: number;
    vartype?: string | undefined;
    volume?: number | undefined;
    wetwt?: number | undefined;
    zoteroUrl?: string | undefined;
    bioGroupId?: number | undefined;
    counmetId?: number | undefined;
    drymetId?: number;
    labId?: number | undefined;
    prepmetId?: number | undefined;
    sampmetId?: number;
    shiftedlat?: number | undefined;
    shiftedlong?: number | undefined;

    constructor(data?: IExportSample) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.begPeriod = _data["begPeriod"] ? new Date(_data["begPeriod"].toString()) : <any>undefined;
            this.bioGroup = _data["bioGroup"];
            this.bodyPar = _data["bodyPar"];
            this.bodyParId = _data["bodyParId"];
            this.counmet = _data["counmet"];
            this.detection = _data["detection"];
            this.displayText = _data["displayText"];
            this.drymet = _data["drymet"];
            this.drywt = _data["drywt"];
            this.endPeriod = _data["endPeriod"] ? new Date(_data["endPeriod"].toString()) : <any>undefined;
            this.filtered = _data["filtered"];
            this.filtpore = _data["filtpore"];
            this.frequency = _data["frequency"];
            this.lab = _data["lab"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.measureNote = _data["measureNote"];
            this.nuclideId = _data["nuclideId"];
            this.nuSymbol = _data["nuSymbol"];
            this.percentwt = _data["percentwt"];
            this.prepmet = _data["prepmet"];
            this.profileId = _data["profileId"];
            this.rangeLow = _data["rangeLow"];
            this.rangeUp = _data["rangeUp"];
            this.refId = _data["refId"];
            this.refFulltext = _data["refFulltext"];
            this.refNote = _data["refNote"];
            this.salinity = _data["salinity"];
            this.samparea = _data["samparea"];
            this.sampleDepth = _data["sampleDepth"];
            this.sampleId = _data["sampleId"];
            this.sampleLabCode = _data["sampleLabCode"];
            this.samplingYear = _data["samplingYear"];
            this.sampmet = _data["sampmet"];
            this.sampNote = _data["sampNote"];
            this.sampType = _data["sampType"];
            this.sampTypeId = _data["sampTypeId"];
            this.sedRepName = _data["sedRepName"];
            this.sedType = _data["sedType"];
            this.sedTypeId = _data["sedTypeId"];
            this.shapeTypeId = _data["shapeTypeId"];
            this.sliceDown = _data["sliceDown"];
            this.sliceUp = _data["sliceUp"];
            this.speciesId = _data["speciesId"];
            this.station = _data["station"];
            this.taxonDbUrl = _data["taxonDbUrl"];
            this.taxonName = _data["taxonName"];
            this.taxonRank = _data["taxonRank"];
            this.taxonRepName = _data["taxonRepName"];
            this.temperature = _data["temperature"];
            this.totalDepth = _data["totalDepth"];
            this.transactId = _data["transactId"];
            this.uncertanity = _data["uncertanity"];
            this.unit = _data["unit"];
            this.unitId = _data["unitId"];
            this.vartype = _data["vartype"];
            this.volume = _data["volume"];
            this.wetwt = _data["wetwt"];
            this.zoteroUrl = _data["zoteroUrl"];
            this.bioGroupId = _data["bioGroupId"];
            this.counmetId = _data["counmetId"];
            this.drymetId = _data["drymetId"];
            this.labId = _data["labId"];
            this.prepmetId = _data["prepmetId"];
            this.sampmetId = _data["sampmetId"];
            this.shiftedlat = _data["shiftedlat"];
            this.shiftedlong = _data["shiftedlong"];
        }
    }

    static fromJS(data: any): ExportSample {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSample();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["begPeriod"] = this.begPeriod ? this.begPeriod.toISOString() : <any>undefined;
        data["bioGroup"] = this.bioGroup;
        data["bodyPar"] = this.bodyPar;
        data["bodyParId"] = this.bodyParId;
        data["counmet"] = this.counmet;
        data["detection"] = this.detection;
        data["displayText"] = this.displayText;
        data["drymet"] = this.drymet;
        data["drywt"] = this.drywt;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        data["filtered"] = this.filtered;
        data["filtpore"] = this.filtpore;
        data["frequency"] = this.frequency;
        data["lab"] = this.lab;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["measureNote"] = this.measureNote;
        data["nuclideId"] = this.nuclideId;
        data["nuSymbol"] = this.nuSymbol;
        data["percentwt"] = this.percentwt;
        data["prepmet"] = this.prepmet;
        data["profileId"] = this.profileId;
        data["rangeLow"] = this.rangeLow;
        data["rangeUp"] = this.rangeUp;
        data["refId"] = this.refId;
        data["refFulltext"] = this.refFulltext;
        data["refNote"] = this.refNote;
        data["salinity"] = this.salinity;
        data["samparea"] = this.samparea;
        data["sampleDepth"] = this.sampleDepth;
        data["sampleId"] = this.sampleId;
        data["sampleLabCode"] = this.sampleLabCode;
        data["samplingYear"] = this.samplingYear;
        data["sampmet"] = this.sampmet;
        data["sampNote"] = this.sampNote;
        data["sampType"] = this.sampType;
        data["sampTypeId"] = this.sampTypeId;
        data["sedRepName"] = this.sedRepName;
        data["sedType"] = this.sedType;
        data["sedTypeId"] = this.sedTypeId;
        data["shapeTypeId"] = this.shapeTypeId;
        data["sliceDown"] = this.sliceDown;
        data["sliceUp"] = this.sliceUp;
        data["speciesId"] = this.speciesId;
        data["station"] = this.station;
        data["taxonDbUrl"] = this.taxonDbUrl;
        data["taxonName"] = this.taxonName;
        data["taxonRank"] = this.taxonRank;
        data["taxonRepName"] = this.taxonRepName;
        data["temperature"] = this.temperature;
        data["totalDepth"] = this.totalDepth;
        data["transactId"] = this.transactId;
        data["uncertanity"] = this.uncertanity;
        data["unit"] = this.unit;
        data["unitId"] = this.unitId;
        data["vartype"] = this.vartype;
        data["volume"] = this.volume;
        data["wetwt"] = this.wetwt;
        data["zoteroUrl"] = this.zoteroUrl;
        data["bioGroupId"] = this.bioGroupId;
        data["counmetId"] = this.counmetId;
        data["drymetId"] = this.drymetId;
        data["labId"] = this.labId;
        data["prepmetId"] = this.prepmetId;
        data["sampmetId"] = this.sampmetId;
        data["shiftedlat"] = this.shiftedlat;
        data["shiftedlong"] = this.shiftedlong;
        return data;
    }
}

export interface IExportSample {
    activity?: number | undefined;
    areaId?: string | undefined;
    areaName?: string | undefined;
    begPeriod?: Date;
    bioGroup?: string | undefined;
    bodyPar?: string | undefined;
    bodyParId?: number;
    counmet?: string | undefined;
    detection?: string | undefined;
    displayText?: string | undefined;
    drymet?: string | undefined;
    drywt?: number | undefined;
    endPeriod?: Date | undefined;
    filtered?: string | undefined;
    filtpore?: string | undefined;
    frequency?: number | undefined;
    lab?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    measureNote?: string | undefined;
    nuclideId?: number;
    nuSymbol?: string | undefined;
    percentwt?: number | undefined;
    prepmet?: string | undefined;
    profileId?: string | undefined;
    rangeLow?: number | undefined;
    rangeUp?: number | undefined;
    refId?: number;
    refFulltext?: string | undefined;
    refNote?: string | undefined;
    salinity?: number | undefined;
    samparea?: number | undefined;
    sampleDepth?: number | undefined;
    sampleId?: number;
    sampleLabCode?: string | undefined;
    samplingYear?: number;
    sampmet?: string | undefined;
    sampNote?: string | undefined;
    sampType?: string | undefined;
    sampTypeId?: number;
    sedRepName?: string | undefined;
    sedType?: string | undefined;
    sedTypeId?: number;
    shapeTypeId?: number;
    sliceDown?: number | undefined;
    sliceUp?: number | undefined;
    speciesId?: number;
    station?: string | undefined;
    taxonDbUrl?: string | undefined;
    taxonName?: string | undefined;
    taxonRank?: string | undefined;
    taxonRepName?: string | undefined;
    temperature?: number | undefined;
    totalDepth?: number | undefined;
    transactId?: string | undefined;
    uncertanity?: number | undefined;
    unit?: string | undefined;
    unitId?: number;
    vartype?: string | undefined;
    volume?: number | undefined;
    wetwt?: number | undefined;
    zoteroUrl?: string | undefined;
    bioGroupId?: number | undefined;
    counmetId?: number | undefined;
    drymetId?: number;
    labId?: number | undefined;
    prepmetId?: number | undefined;
    sampmetId?: number;
    shiftedlat?: number | undefined;
    shiftedlong?: number | undefined;
}

export class MinimizedMeasurementData implements IMinimizedMeasurementData {
    result?: string;

    constructor(data?: IMinimizedMeasurementData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): MinimizedMeasurementData {
        data = typeof data === 'object' ? data : {};
        let result = new MinimizedMeasurementData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }
}

export interface IMinimizedMeasurementData {
    result?: string;
}

export class HomePageDataDTO implements IHomePageDataDTO {
    sampleTypeId?: number;
    numberOfSamples?: number;
    numberOfMeasurements?: number;

    constructor(data?: IHomePageDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleTypeId = _data["sampleTypeId"];
            this.numberOfSamples = _data["numberOfSamples"];
            this.numberOfMeasurements = _data["numberOfMeasurements"];
        }
    }

    static fromJS(data: any): HomePageDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HomePageDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleTypeId"] = this.sampleTypeId;
        data["numberOfSamples"] = this.numberOfSamples;
        data["numberOfMeasurements"] = this.numberOfMeasurements;
        return data;
    }
}

export interface IHomePageDataDTO {
    sampleTypeId?: number;
    numberOfSamples?: number;
    numberOfMeasurements?: number;
}

export class SampleDetailsDTO implements ISampleDetailsDTO {
    bioGroup?: string[];
    nuclides?: string[];
    latitude?: number | undefined;
    longitude?: number | undefined;
    numberOfSamples?: number;
    numberOfDatasets?: number;
    numberOfMeasures?: number;
    numberOfTaxons?: number;
    samplingDepth?: string;
    samplingYear?: string;
    datasets?: string[];
    detection?: string;
    numberOfSamplesWithEqualType?: number;
    numberOfSamplesWithoutEqualType?: number;

    constructor(data?: ISampleDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bioGroup"])) {
                this.bioGroup = [] as any;
                for (let item of _data["bioGroup"])
                    this.bioGroup!.push(item);
            }
            if (Array.isArray(_data["nuclides"])) {
                this.nuclides = [] as any;
                for (let item of _data["nuclides"])
                    this.nuclides!.push(item);
            }
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.numberOfSamples = _data["numberOfSamples"];
            this.numberOfDatasets = _data["numberOfDatasets"];
            this.numberOfMeasures = _data["numberOfMeasures"];
            this.numberOfTaxons = _data["numberOfTaxons"];
            this.samplingDepth = _data["samplingDepth"];
            this.samplingYear = _data["samplingYear"];
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(item);
            }
            this.detection = _data["detection"];
            this.numberOfSamplesWithEqualType = _data["numberOfSamplesWithEqualType"];
            this.numberOfSamplesWithoutEqualType = _data["numberOfSamplesWithoutEqualType"];
        }
    }

    static fromJS(data: any): SampleDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SampleDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bioGroup)) {
            data["bioGroup"] = [];
            for (let item of this.bioGroup)
                data["bioGroup"].push(item);
        }
        if (Array.isArray(this.nuclides)) {
            data["nuclides"] = [];
            for (let item of this.nuclides)
                data["nuclides"].push(item);
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["numberOfSamples"] = this.numberOfSamples;
        data["numberOfDatasets"] = this.numberOfDatasets;
        data["numberOfMeasures"] = this.numberOfMeasures;
        data["numberOfTaxons"] = this.numberOfTaxons;
        data["samplingDepth"] = this.samplingDepth;
        data["samplingYear"] = this.samplingYear;
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item);
        }
        data["detection"] = this.detection;
        data["numberOfSamplesWithEqualType"] = this.numberOfSamplesWithEqualType;
        data["numberOfSamplesWithoutEqualType"] = this.numberOfSamplesWithoutEqualType;
        return data;
    }
}

export interface ISampleDetailsDTO {
    bioGroup?: string[];
    nuclides?: string[];
    latitude?: number | undefined;
    longitude?: number | undefined;
    numberOfSamples?: number;
    numberOfDatasets?: number;
    numberOfMeasures?: number;
    numberOfTaxons?: number;
    samplingDepth?: string;
    samplingYear?: string;
    datasets?: string[];
    detection?: string;
    numberOfSamplesWithEqualType?: number;
    numberOfSamplesWithoutEqualType?: number;
}

export class SampleDetailSearchDTO implements ISampleDetailSearchDTO {
    filterValues?: SearchFilterDTO;
    sampleId?: number;
    geoSpatialString?: string;

    constructor(data?: ISampleDetailSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterValues = _data["filterValues"] ? SearchFilterDTO.fromJS(_data["filterValues"]) : <any>undefined;
            this.sampleId = _data["sampleId"];
            this.geoSpatialString = _data["geoSpatialString"];
        }
    }

    static fromJS(data: any): SampleDetailSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SampleDetailSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterValues"] = this.filterValues ? this.filterValues.toJSON() : <any>undefined;
        data["sampleId"] = this.sampleId;
        data["geoSpatialString"] = this.geoSpatialString;
        return data;
    }
}

export interface ISampleDetailSearchDTO {
    filterValues?: SearchFilterDTO;
    sampleId?: number;
    geoSpatialString?: string;
}

export class SearchFilterContentDTO implements ISearchFilterContentDTO {
    filterValue?: FilterValueDTO;
    sampleTypeId?: number;
    shapeTypeId?: number;

    constructor(data?: ISearchFilterContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterValue = _data["filterValue"] ? FilterValueDTO.fromJS(_data["filterValue"]) : <any>undefined;
            this.sampleTypeId = _data["sampleTypeId"];
            this.shapeTypeId = _data["shapeTypeId"];
        }
    }

    static fromJS(data: any): SearchFilterContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFilterContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterValue"] = this.filterValue ? this.filterValue.toJSON() : <any>undefined;
        data["sampleTypeId"] = this.sampleTypeId;
        data["shapeTypeId"] = this.shapeTypeId;
        return data;
    }
}

export interface ISearchFilterContentDTO {
    filterValue?: FilterValueDTO;
    sampleTypeId?: number;
    shapeTypeId?: number;
}

export class FilterValueDTO implements IFilterValueDTO {
    bioGroups?: number[];
    bodyParts?: number[];
    dataSets?: number[];
    nuclides?: number[];
    samplingDepthFrom?: number | undefined;
    samplingDepthTo?: number | undefined;
    samplingYears?: number[];
    seaAreas?: string[];
    sedimentTypes?: string;

    constructor(data?: IFilterValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bioGroups"])) {
                this.bioGroups = [] as any;
                for (let item of _data["bioGroups"])
                    this.bioGroups!.push(item);
            }
            if (Array.isArray(_data["bodyParts"])) {
                this.bodyParts = [] as any;
                for (let item of _data["bodyParts"])
                    this.bodyParts!.push(item);
            }
            if (Array.isArray(_data["dataSets"])) {
                this.dataSets = [] as any;
                for (let item of _data["dataSets"])
                    this.dataSets!.push(item);
            }
            if (Array.isArray(_data["nuclides"])) {
                this.nuclides = [] as any;
                for (let item of _data["nuclides"])
                    this.nuclides!.push(item);
            }
            this.samplingDepthFrom = _data["samplingDepthFrom"];
            this.samplingDepthTo = _data["samplingDepthTo"];
            if (Array.isArray(_data["samplingYears"])) {
                this.samplingYears = [] as any;
                for (let item of _data["samplingYears"])
                    this.samplingYears!.push(item);
            }
            if (Array.isArray(_data["seaAreas"])) {
                this.seaAreas = [] as any;
                for (let item of _data["seaAreas"])
                    this.seaAreas!.push(item);
            }
            this.sedimentTypes = _data["sedimentTypes"];
        }
    }

    static fromJS(data: any): FilterValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bioGroups)) {
            data["bioGroups"] = [];
            for (let item of this.bioGroups)
                data["bioGroups"].push(item);
        }
        if (Array.isArray(this.bodyParts)) {
            data["bodyParts"] = [];
            for (let item of this.bodyParts)
                data["bodyParts"].push(item);
        }
        if (Array.isArray(this.dataSets)) {
            data["dataSets"] = [];
            for (let item of this.dataSets)
                data["dataSets"].push(item);
        }
        if (Array.isArray(this.nuclides)) {
            data["nuclides"] = [];
            for (let item of this.nuclides)
                data["nuclides"].push(item);
        }
        data["samplingDepthFrom"] = this.samplingDepthFrom;
        data["samplingDepthTo"] = this.samplingDepthTo;
        if (Array.isArray(this.samplingYears)) {
            data["samplingYears"] = [];
            for (let item of this.samplingYears)
                data["samplingYears"].push(item);
        }
        if (Array.isArray(this.seaAreas)) {
            data["seaAreas"] = [];
            for (let item of this.seaAreas)
                data["seaAreas"].push(item);
        }
        data["sedimentTypes"] = this.sedimentTypes;
        return data;
    }
}

export interface IFilterValueDTO {
    bioGroups?: number[];
    bodyParts?: number[];
    dataSets?: number[];
    nuclides?: number[];
    samplingDepthFrom?: number | undefined;
    samplingDepthTo?: number | undefined;
    samplingYears?: number[];
    seaAreas?: string[];
    sedimentTypes?: string;
}

export class SampleDataDTO implements ISampleDataDTO {
    id?: number;
    measureCount?: number;
    pos?: string;

    constructor(data?: ISampleDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.measureCount = _data["measureCount"];
            this.pos = _data["pos"];
        }
    }

    static fromJS(data: any): SampleDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SampleDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["measureCount"] = this.measureCount;
        data["pos"] = this.pos;
        return data;
    }
}

export interface ISampleDataDTO {
    id?: number;
    measureCount?: number;
    pos?: string;
}

export class MinimizedSampleData implements IMinimizedSampleData {
    result?: string;

    constructor(data?: IMinimizedSampleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): MinimizedSampleData {
        data = typeof data === 'object' ? data : {};
        let result = new MinimizedSampleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }
}

export interface IMinimizedSampleData {
    result?: string;
}

export class SedTypeDTO implements ISedTypeDTO {
    sedType_Id?: number;
    sedType?: string;
    code?: string;
    sedsize?: string;

    constructor(data?: ISedTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sedType_Id = _data["sedType_Id"];
            this.sedType = _data["sedType"];
            this.code = _data["code"];
            this.sedsize = _data["sedsize"];
        }
    }

    static fromJS(data: any): SedTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SedTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sedType_Id"] = this.sedType_Id;
        data["sedType"] = this.sedType;
        data["code"] = this.code;
        data["sedsize"] = this.sedsize;
        return data;
    }
}

export interface ISedTypeDTO {
    sedType_Id?: number;
    sedType?: string;
    code?: string;
    sedsize?: string;
}

export class SpeciesDTO implements ISpeciesDTO {
    species_Id?: number;
    species?: string;
    taxonname?: string;
    taxonrank?: string;
    taxonDB?: string;
    taxonDBID?: string;
    taxonDBURL?: string;
    taxonDB2?: string;
    taxonDBID2?: string;
    taxonDBURL2?: string;
    biogroup_id?: number | undefined;

    constructor(data?: ISpeciesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.species_Id = _data["species_Id"];
            this.species = _data["species"];
            this.taxonname = _data["taxonname"];
            this.taxonrank = _data["taxonrank"];
            this.taxonDB = _data["taxonDB"];
            this.taxonDBID = _data["taxonDBID"];
            this.taxonDBURL = _data["taxonDBURL"];
            this.taxonDB2 = _data["taxonDB2"];
            this.taxonDBID2 = _data["taxonDBID2"];
            this.taxonDBURL2 = _data["taxonDBURL2"];
            this.biogroup_id = _data["biogroup_id"];
        }
    }

    static fromJS(data: any): SpeciesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["species_Id"] = this.species_Id;
        data["species"] = this.species;
        data["taxonname"] = this.taxonname;
        data["taxonrank"] = this.taxonrank;
        data["taxonDB"] = this.taxonDB;
        data["taxonDBID"] = this.taxonDBID;
        data["taxonDBURL"] = this.taxonDBURL;
        data["taxonDB2"] = this.taxonDB2;
        data["taxonDBID2"] = this.taxonDBID2;
        data["taxonDBURL2"] = this.taxonDBURL2;
        data["biogroup_id"] = this.biogroup_id;
        return data;
    }
}

export interface ISpeciesDTO {
    species_Id?: number;
    species?: string;
    taxonname?: string;
    taxonrank?: string;
    taxonDB?: string;
    taxonDBID?: string;
    taxonDBURL?: string;
    taxonDB2?: string;
    taxonDBID2?: string;
    taxonDBURL2?: string;
    biogroup_id?: number | undefined;
}

export class UnitDTO implements IUnitDTO {
    unit_Id?: number;
    unit?: string;
    ordlist?: number;

    constructor(data?: IUnitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit_Id = _data["unit_Id"];
            this.unit = _data["unit"];
            this.ordlist = _data["ordlist"];
        }
    }

    static fromJS(data: any): UnitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit_Id"] = this.unit_Id;
        data["unit"] = this.unit;
        data["ordlist"] = this.ordlist;
        return data;
    }
}

export interface IUnitDTO {
    unit_Id?: number;
    unit?: string;
    ordlist?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}